"use client";

import { useEffect, useState } from "react";
import { LotteryDashboard } from "@/components/dashboard/lottery-dashboard";

type UserData = {
  userId?: string;
  role?: string;
};

export default function DashboardPage() {
  const [user, setUser] = useState<UserData | null>(null);

  useEffect(() => {
    const data = localStorage.getItem("user_data");
    if (data) {
      setUser(JSON.parse(data) as UserData);
    }
  }, []);

  const userRole: "user" | "admin" =
    user?.role?.toLowerCase() === "admin" ? "admin" : "user";

  return (
    <LotteryDashboard
      username={user?.userId || "DEMO USER"}
      userRole={userRole}
    />
  );
}
